(function () {
  'use strict';

  class PlPortfolioCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.pl-portfolio__track');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      if (!this.track) return;

      this.cards = Array.from(this.track.querySelectorAll('.pl-portfolio__card'));
      this.index = 0;
      this.visibleCount = this._visibleCount();

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this._prev());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this._next());

      window.addEventListener('resize', () => {
        this.visibleCount = this._visibleCount();
        this._update();
      });

      this._update();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._update);
    }

    _visibleCount() {
      if (window.innerWidth >= 1200) return 4;
      if (window.innerWidth >= 900) return 3;
      if (window.innerWidth >= 600) return 2;
      return 1;
    }

    _maxIndex() {
      return Math.max(0, this.cards.length - this.visibleCount);
    }

    _prev() {
      this.index = Math.max(0, this.index - 1);
      this._update();
    }

    _next() {
      this.index = Math.min(this._maxIndex(), this.index + 1);
      this._update();
    }

    _update() {
      var card = this.cards[0];
      if (!card) return;
      var cardWidth = card.offsetWidth + 32;
      this.track.style.transform = 'translateX(-' + (this.index * cardWidth) + 'px)';
      if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.index >= this._maxIndex();
    }
  }

  customElements.define('pl-portfolio-carousel', PlPortfolioCarousel);
})();
